import React from "react";
import configuration from "../utilities/configuration";

export enum LogoutReason {
    Default = "default",
    Timeout = "timeout",
    InsufficientRoles = "insufficientRoles",
    Locked = "locked",
    UndefinedState = "undefinedState"
}

const idleTimeoutMinDefault =  15;
export const idleTimeoutMin = configuration?.logoutIdleTimeoutMin || idleTimeoutMinDefault;

export const logoutTexts = {
    [LogoutReason.Timeout]: "You have been logged out due to your inactivity.",
    [LogoutReason.InsufficientRoles]: "You have been logged out due to insufficient roles.",
    [LogoutReason.UndefinedState]: (
        <div>
            There is an unexpected problem with your account. Please contact our customer support via{" "}
            <a href="mailto:hdp@deutsche-boerse.com.">hdp@deutsche-boerse.com.</a> or at +49-(0) 69-2 11-1 10 33.
        </div>
    ),
    [LogoutReason.Locked]: (
        <div>
            Your account is locked. Please contact our customer support via{" "}
            <a href="mailto:hdp@deutsche-boerse.com.">hdp@deutsche-boerse.com.</a> or at +49-(0) 69-2 11-1 10 33.
        </div>
    ),
    [LogoutReason.Default]: "You are logged out now."
};

export const getLogoutReason = reason => {
    return logoutTexts[reason] || logoutTexts[LogoutReason.Default];
};
